import classNames from "classnames";
import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { grb2Selectors } from "redux/app/grb2";
import {
	EGRB2State,
	IGarbageAccidentalLoss,
	IGarbageDischargedIntoSea,
	IGarbageDischargedToReceptionAshoreOrOtherShips,
} from "../../../../redux/app/grb2/@types";
import { IStore } from "../../../../redux/store";
import GRB2Participants from "./Table/GRB2Participants";

type OwnProps = {};
type GRB2PrintViewProps = PropsFromRedux & OwnProps;
function GRB2PrintView(props: GRB2PrintViewProps) {
	const { historyList } = props;
	return (
		<div className="py-6 ws-scroll">
			<div className="px-6 mb-12">
				<h3 className="mb-8 text-xl font-bold font-redhat-display">
					RECORD OF GARBAGE DISCHARGES - &#8545;
				</h3>

				<h4 className="mb-4 font-medium">Garbage categories</h4>
				<div className="flex mb-4 border border-gray-500">
					<div className="p-2" style={{ flexBasis: "50%" }}>
						<b>J:</b>
						<span>Cargo residues (non-HME)</span>
					</div>
					<div
						className="p-2 border-l border-gray-500"
						style={{ flexBasis: "50%" }}
					>
						<b>K:</b>
						<span>Cargo residues (non-HME)</span>
					</div>
				</div>

				<h4 className="w-3/4 font-medium leading-5 tracking-wide text-gray-600">
					Discharges under regulations 4 (Discharge of garbage outside special
					areas) and 6(Discharge of garbage within special areas)
				</h4>
			</div>
			<div className="px-6 mb-12 rounded-md">
				<table className="marpol-table grb2-table">
					<thead>
						<tr>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								rowSpan={2}
							>
								Date<span className="invisible">/Time</span>
							</th>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								rowSpan={2}
							>
								Position of the ship (latitude/longitude) or port if disposed of
								ashore
							</th>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								rowSpan={2}
							>
								Category
							</th>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								colSpan={2}
							>
								Estimated amount discharged
							</th>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								rowSpan={2}
							>
								Start and stop positions of the ship for discharges into the sea
							</th>
							<th
								className="p-3 font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400"
								rowSpan={2}
							>
								Certification/ Signature
							</th>
						</tr>
						<tr>
							<th className="p-3 text-sm font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400">
								Into sea (m³)
							</th>
							<th className="p-3 text-sm font-medium tracking-wide text-left text-gray-700 align-top bg-white border border-gray-400">
								To reception facilities or to another ship (m³)
							</th>
						</tr>
					</thead>
					<tbody>
						{historyList
							.sort((record1, record2) =>
								moment(record1.selectedDate, "YYYY-MM-DD").isBefore(
									moment(record2.selectedDate, "YYYY-MM-DD")
								)
									? -1
									: 0
							)
							.map((record) => (
								<React.Fragment key={record.id}>
									{Array.isArray(record.garbage)
										? record.garbage.map((garbage, index) => {
												return (
													<tr
														key={index}
														className={classNames("leading-5", {
															"line-through":
																record.state === EGRB2State.STRIKED_OFF,
														})}
													>
														<td
															className="p-3 px-6 font-normal text-left text-gray-800 border border-gray-400"
															rowSpan={record.editHistory.length > 0 ? 2 : 1}
														>
															<div className="h-full">
																<span className="block font-medium whitespace-nowrap">
																	{moment(
																		record.selectedDate,
																		"YYYY-MM-DD"
																	).format("DD-MMM-YYYY")}
																</span>
															</div>
														</td>
														<td className="p-3 px-6 font-normal leading-5 text-left text-gray-800 border border-gray-400">
															{(() => {
																switch (record.entry) {
																	case "ACCIDENTAL_OR_LOSS_OF_GARBAGE_INTO_SEA":
																		return (
																			<div className="h-full leading-5 font-redhat-text">
																				<span className="block font-medium whitespace-nowrap">
																					{
																						(record as IGarbageAccidentalLoss)
																							.locationOfOccurance
																					}
																				</span>
																			</div>
																		);
																	case "GARBAGE_DISCHARGED_INTO_SEA":
																		return (
																			<div className="h-full leading-5 font-redhat-text">
																				<span className="block font-medium whitespace-nowrap">
																					Lat{" "}
																					{
																						(
																							record as IGarbageDischargedIntoSea
																						).locationOfStartOfDischarge
																							.latitude
																					}
																				</span>
																				<span className="block font-medium whitespace-nowrap">
																					Long{" "}
																					{
																						(
																							record as IGarbageDischargedIntoSea
																						).locationOfStartOfDischarge
																							.longitude
																					}
																				</span>
																			</div>
																		);
																	case "GARBAGE_DISCHARGED_TO_RECEPTION_ASHORE_OR_OTHER_SHIPS":
																		return (
																			<div className="h-full leading-5 font-redhat-text">
																				<span className="block font-medium whitespace-nowrap">
																					{
																						(
																							record as IGarbageDischargedToReceptionAshoreOrOtherShips
																						).placeOfDischarge
																					}
																				</span>
																				<span className="block font-medium whitespace-nowrap">
																					{" "}
																					{
																						(
																							record as IGarbageDischargedToReceptionAshoreOrOtherShips
																						).placeOfDischarge
																					}
																				</span>
																			</div>
																		);
																}
															})()}
														</td>
														<td className="p-3 px-6 font-medium text-left text-gray-800 border border-gray-400">
															<div className="h-full font-medium">
																{garbage.category}
															</div>
														</td>
														<td className="p-3 px-6 font-normal text-left text-gray-800 border border-gray-400">
															<h4 className="font-medium capitalize">
																{(record.entry ===
																	"GARBAGE_DISCHARGED_INTO_SEA" ||
																	record.entry ===
																		"ACCIDENTAL_OR_LOSS_OF_GARBAGE_INTO_SEA") &&
																garbage
																	? garbage.estimatedAmountDischarged
																	: "-"}
															</h4>
														</td>
														<td className="p-3 px-6 font-normal text-left text-gray-800 border border-gray-400">
															<div className="h-full font-medium">
																{record.entry ===
																	"GARBAGE_DISCHARGED_TO_RECEPTION_ASHORE_OR_OTHER_SHIPS" &&
																garbage
																	? garbage.estimatedAmountDischarged
																	: "-"}
															</div>
														</td>
														<td className="p-3 px-6 font-normal text-left text-gray-800 border border-gray-400">
															<div className="h-full font-medium leading-6 tracking-wide">
																{record.remark}
															</div>
														</td>
														<td
															className="p-3 px-6 font-normal text-left text-gray-800 border border-gray-400 "
															style={{
																textDecoration: "none",
															}}
														>
															{record.state === EGRB2State.APPROVED ? (
																<GRB2Participants grb2Record={record} />
															) : (
																<div className="h-full font-medium">--</div>
															)}
														</td>
													</tr>
												);
										  })
										: null}
								</React.Fragment>
							))}
					</tbody>
				</table>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const grb2Store = grb2Selectors._getStore(store);
	return {
		historyList: grb2Selectors.getHistoryList(grb2Store),
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GRB2PrintView);
